import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Tooltip.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/design/components/tooltip/react'} mdxType="DeprecationBanner" />
    <p>{`The Tooltip component adds a tooltip to add context to interactive elements on the page.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`⚠️ Usage warning! ⚠️`}</em></strong></p>
    <p>{`Tooltips as a UI pattern should be our last resort for conveying information because it is hidden by default and often with zero or little visual indicator of its existence.`}</p>
    <p>{`Before adding a tooltip, please consider: Is this information essential and necessary? Can the UI be made clearer? Can the information be shown on the page by default? See `}<a parentName="p" {...{
        "href": "https://primer.style/design/accessibility/tooltip-alternatives"
      }}>{`Tooltip alternatives`}</a>{` for more accessible alternatives.`}</p>
    <p><strong parentName="p">{`Attention:`}</strong>{` we use `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` for tooltip contents. However, `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` replaces the text content of an element in screen readers, so only use Tooltip on elements with no existing text content.`}</p>
    <p>{`A tooltip may only be used on an element that is interactive such as a button or a link. Even if an element is focusable, a tooltip may only be used if the element does something when it's clicked.`}</p>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box borderWidth="1px" borderStyle="solid" borderColor="border.default" borderRadius={2} p={3}>
  <Tooltip aria-label="Hello, Tooltip!">
    <Button>Hover me</Button>
  </Tooltip>
</Box>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      